import DatePicker, { DEFAULT_DATE_FORMAT } from '../Fundamentals/DatePicker';

export function DateInterval({ 
    dateFormat = DEFAULT_DATE_FORMAT, 
    showTime = false, 
    onChangeFromDate, 
    onChangeToDate, 
    fromDateValue, 
    toDateValue 
}) {
    return (
        <div className="d-flex">
            <div className="flex-grow-1">
                <DatePicker 
                    dateFormat={dateFormat} 
                    showTime={showTime} 
                    onChange={onChangeFromDate} 
                    value={fromDateValue}
                />
            </div>
            <div className="mx-12">
                <p>_</p>
            </div>
            <div className="flex-grow-1">
                <DatePicker 
                    dateFormat={dateFormat} 
                    showTime={showTime} 
                    onChange={onChangeToDate} 
                    value={toDateValue}
                />
            </div>
        </div>
    )
}